module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Bold.671db5f8.ttf";